<tiime-list>
  @for (tag of tags; track trackById($index, tag)) {
    <tiime-list-item>
      <div tiimeListItemTitle>
        <span class="tag-name" [class.disabled]="tag.archivedAt">{{ tag.name }}</span>
      </div>
      @if (tag.archivedAt) {
        <span class="tag-archived">
          {{ 'Archivé le' | atBy: tag.archivedAt : tag.archivedBy?.fullName }}
        </span>
      }
      <div tiimeListItemActions>
        @if (tag.archivedAt) {
          <button tiime-button color="primary" icon tiimeTooltip="Désarchiver" (click)="emitUnarchiveTag(tag)">
            <mat-icon svgIcon="icon-unarchived"></mat-icon>
          </button>
        } @else {
          <button tiime-button color="primary" icon tiimeTooltip="Archiver" (click)="emitArchiveTag(tag)">
            <mat-icon svgIcon="icon-archived"></mat-icon>
          </button>
        }
      </div>
    </tiime-list-item>
  }
</tiime-list>
